/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import IconFont from '$/components/IconFont';
import type { MyIpItem } from '$/domains/myIp/types';
import { handleImageUrl } from '$/utils/image';

/** IP 封面按展示尺寸加载缩略图，加载失败时使用现有角色占位图标。 */
export default function IpCover({
  item,
  thumbnailWidth,
  className,
  placeholderClassName,
  placeholderIconSize,
}: {
  item: MyIpItem;
  thumbnailWidth: number;
  className: string;
  placeholderClassName: string;
  placeholderIconSize: number;
}) {
  const [failedUrl, setFailedUrl] = useState<string>();
  if (!item.coverUrl || item.coverUrl === failedUrl) {
    return (
      <span className={placeholderClassName} aria-hidden="true">
        <IconFont name="portraitPhotoBold" fontSize={placeholderIconSize} />
      </span>
    );
  }
  return (
    <img
      className={className}
      src={handleImageUrl(item.coverUrl, {
        width: thumbnailWidth,
        height: thumbnailWidth,
        mode: 3,
      })}
      alt=""
      crossOrigin="anonymous"
      width={thumbnailWidth}
      loading="lazy"
      draggable={false}
      onError={() => setFailedUrl(item.coverUrl)}
    />
  );
}
